export default "__VITE_ASSET__CYqmYUrS__"